enum SeasonType{
    Spring, Summer, Autumn, Winter
}

export default SeasonType;

